/* eslint-disable prefer-destructuring */
/* eslint-disable no-shadow */

const state = {

};

const getters = {
	// query: state => type => state['query/tracks'],
};

const mutations = {

};

const actions = {
	'tracks/list': async function ({ dispatch, commit }, reset = false) {
		commit('SET_DATA_LOADING', { value: true, type: 'tracks' });

		commit('REQUEST_PREVENT_DESTRUCTURE', true);
		const tracks = await this.$sdk.admin().track.get();
		commit('REQUEST_PREVENT_DESTRUCTURE', false);

		if (tracks.ok) {
			dispatch('addData', { data: { results: [tracks.data], total: 1 }, type: 'tracks', reset });
		}

		commit('SET_DATA_LOADING', { value: false, type: 'tracks' });

		return true;
	},
};

export default {
	state,
	getters,
	actions,
	mutations,
};
